import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { withTheme } from 'emotion-theming';
import { themeGet } from 'styled-system';
import { Box, Text } from 'roo-ui/components';
import get from 'lodash/get';
import { FEATURED_PROPERTY_SOURCES } from 'lib/enums/property';

const getReferrerData = (referrer) => {
  switch (referrer.toUpperCase()) {
    case 'TRIVAGO':
      return FEATURED_PROPERTY_SOURCES.TRIVAGO;
    case 'TRIPADVISOR':
      return FEATURED_PROPERTY_SOURCES.TRIPADVISOR;
    case 'GOOGLE':
    case 'GOOGLEHOTELS':
      return FEATURED_PROPERTY_SOURCES.GOOGLEHOTELS;
    case 'EMAIL':
      return FEATURED_PROPERTY_SOURCES.EMAIL;
    default:
      return FEATURED_PROPERTY_SOURCES.DEFAULT;
  }
};

const SearchResultHighlighterWrapper = styled(Box)`
  border-radius: 0 0 0 ${themeGet('radii.default')};
  position: relative;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: ${themeGet('zIndices.highlightBorder')};
    border: 2px solid ${(props) => props.highlightColor};
    border-top-width: 0;
    pointer-events: none;
  }
`;

SearchResultHighlighterWrapper.displayName = 'SearchResultHighlighterWrapper';

const getThemeColor = (color, theme) => get(theme, `colors.${color}`) || color;

const SearchResultHighlighter = ({ children, referrer = 'default', theme }) => {
  const referrerData = getReferrerData(referrer);
  const text = referrerData.text;
  const color = getThemeColor(referrerData.color, theme);
  const background = getThemeColor(referrerData.background, theme);
  const heading = `You picked this hotel ${text}`.trim();

  return (
    <div>
      <Box bg={background} py="2" px={[4, 5]} borderRadius="defaultRoundTopOnly" data-testid="search-result-heading">
        <Text fontSize={['base', 'lg']} color={color}>
          {heading}
        </Text>
      </Box>
      <SearchResultHighlighterWrapper highlightColor={background}>{children}</SearchResultHighlighterWrapper>
    </div>
  );
};

SearchResultHighlighter.propTypes = {
  children: PropTypes.node.isRequired,
  referrer: PropTypes.string,
  theme: PropTypes.object.isRequired,
};

SearchResultHighlighter.defaultProps = {
  referrer: '',
};

export default withTheme(SearchResultHighlighter);
